import { DeliveryActionActions } from '../../store/orm/Action';

export const fetchDeliveryActions = ({ parcel: { parcelCode } }: any) =>
  DeliveryActionActions.fetchDeliveryActionsByCode(parcelCode);
